<template>
  <button class="quiz-item" :class="{ '-image': image }" @click="click">
    <div class="quiz-item__inner" :class="{ '-image': image }">
      <div
        class="quiz-item__content"
        :class="{ '-image': image }"
        v-html="parsedDescription"
      ></div>
      <div
        v-if="image"
        class="quiz-item__image"
        :style="{ backgroundImage: `url(${image})` }"
      ></div>
      <div v-if="!image" class="quiz-item__decorator"></div>
    </div>
  </button>
</template>

<script>
import showdown from "showdown";

export default {
  name: "QuizItem",
  props: {
    description: {
      type: String,
      default: undefined,
      required: true
    },
    image: {
      type: [String, null],
      default: null,
      required: false
    }
  },
  methods: {
    click: function() {
      this.$emit("click");
    }
  },
  computed: {
    parsedDescription: function() {
      const converter = new showdown.Converter();
      const convertedString = converter.makeHtml(this.description);
      return convertedString;
    }
  }
};
</script>

<style lang="scss" scoped>
.quiz-item {
  $_parent: &;
  align-items: stretch;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  transition: cta-transition(transform);

  &__inner {
    background-color: theme-color("body");
    border-radius: sizes("border-radius");
    border: 1px solid theme-color("border");
    box-shadow: theme-color("shadow");
    display: flex;
    overflow: hidden;
    position: relative;
    width: 100%;
    transition: cta-transition(background-color);

    @include if-tablet {
      flex-grow: 1;
    }

    &.-image {
      @include if-tablet {
        flex-direction: column;
      }
    }
  }

  &__content {
    align-items: center;
    color: theme-color("black");
    display: flex;
    font-family: $font-family;
    font-size: px-to-rem(18px);
    font-weight: 400;
    padding: spacer("m");
    text-align: left;
    transition: cta-transition(color);
    width: 100%;
    z-index: z-index("emphasized");

    @include if-tablet {
      font-size: px-to-rem(20px);
      line-height: 1.4;
    }

    @include if-desktop {
      font-size: px-to-rem(26px);
    }
  }

  &__decorator {
    $_decorator-transitions: height, background-color;
    background-color: theme-color("accent-1");
    border-left: 1px solid theme-color("border");
    border-top: 0;
    flex-shrink: 0;
    width: 14px;
    z-index: z-index("content");

    @include if-tablet {
      border-left: 0;
      border-top: 1px solid theme-color("border");
      bottom: 0;
      height: 30px;
      position: absolute;
      width: 100%;
      transition: cta-transition($_decorator-transitions);
    }
  }

  &__image {
    background-position: center;
    background-size: cover;
    height: 80px;
    overflow: hidden;
    width: 100%;
    z-index: z-index("content");

    @include if-tablet {
      flex-grow: 1;
      height: 100%;
    }
  }

  &:active {
    #{$_parent}__decorator,
    #{$_parent}__inner {
      background-color: darken(theme-color("accent-1"), 10%);
    }

    #{$_parent}__content {
      color: theme-color("body");
    }
  }

  &:hover {
    @include if-tablet {
      transform: scale(1.08);

      #{$_parent}__content:not(.-image) {
        color: theme-color("body");
      }

      #{$_parent}__decorator {
        height: 100%;
      }
    }
  }
}
</style>
